import { render, staticRenderFns } from "./UploadWorkflow.vue?vue&type=template&id=68058e3e&"
import script from "./UploadWorkflow.vue?vue&type=script&lang=ts&"
export * from "./UploadWorkflow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports